export default __webpack_public_path__ + "images/onout-dex_32ed51.png";